import React, { useEffect } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  finalSupplierListAtom,
  showFinalizedListAtom,
  supplierSearchListAtom,
  filtersCheckBoxAtom,
} from '../../../Services/_states';
import ReactBootstrapTable from '../../Table/React-Bootstrap-table/ReactBootstrapTable';
import { Button } from 'react-bootstrap';
import DataNotFound from '../../../components/Shared/DataNotFound';
import { BookinPlanActions } from '../../../Services/_actions';
import { BookingFunctions } from './BookingFunctions';

export default function SupplierSearchList() {
  const BookingApi = BookinPlanActions();
  const UpdateData = BookingFunctions();
  const suppliersData = useRecoilValue(supplierSearchListAtom);
  const showFinalizedList = useRecoilValue(showFinalizedListAtom);
  const [finalSupplierList, setFinalSupplierList] = useRecoilState(finalSupplierListAtom);
  const filtersCheckbox = useRecoilValue(filtersCheckBoxAtom);

  const Header = [
    {
      title: '#',
      accessKey: 'index',
      sort: false,
      action: function (row, index) {
        return index + 1;
      },
    },
    {
      title: 'NAME',
      accessKey: 'name',
      sort: false,
    },
    {
      title: 'CITY',
      accessKey: 'city',
      sort: false,
    },
    {
      title: 'AREA',
      accessKey: 'area',
      sort: false,
    },
    {
      title: 'SUB-AREA',
      accessKey: 'subarea',
      sort: false,
    },
    {
      title: 'ACTION',
      accessKey: 'ACTION',
      sort: false,
      action: function (row, index) {
        return (
          <div>
            {showFinalizedList ? (
              <Button
                className="btn btn-primary"
                onClick={(e) => {
                  UpdateData.addSupplierList(row, index);
                }}
              >
                Add
              </Button>
            ) : (
              <div className="action-icon">
                <span
                  className="action-icon-item"
                  onClick={(e) => {
                    UpdateData.removeSupplierList(row, index);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-trash"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                  </svg>
                </span>
              </div>
            )}
          </div>
        );
      },
    },
  ];

  const handleSubmit = async () => {
    await BookingApi.submitSupplierList();
  };

  if (showFinalizedList) {
    return (
      <div>
        {suppliersData.length > 0 ? (
          <ReactBootstrapTable headerData={Header} rowData={suppliersData} />
        ) : (
          <DataNotFound message="No Supplier Found" />
        )}
      </div>
    );
  } else {
    return (
      <div>
        {finalSupplierList.length > 0 ? (
          <>
            <ReactBootstrapTable headerData={Header} rowData={finalSupplierList} />
            <Button
              className="btn btn-primary"
              onClick={(e) => {
                handleSubmit();
              }}
            >
              Submit
            </Button>
          </>
        ) : (
          <DataNotFound message="No Data Found" />
        )}
      </div>
    );
  }
}
